import { render, staticRenderFns } from "./ComparisonBarGraph.vue?vue&type=template&id=2a23e45a&scoped=true&"
import script from "./ComparisonBarGraph.vue?vue&type=script&lang=js&"
export * from "./ComparisonBarGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a23e45a",
  null
  
)

export default component.exports